import React from 'react';
import * as constantClass from '../fileWithConstants';
import { createPagedGridController } from '../../hooks/pagedGridClassAdapter';
import * as periodosService from '../../services/periodos/periodosService';
import { classifyPeriodosError } from '../../services/periodos/periodosDto';
import { LookupModal, LookupSelectButton, LookupActionHeader } from '../common/LookupModal';
import { createLookupSearchHandlers } from '../common/lookupGridSearch';

export class LookupPeriodoExamen extends React.Component {
  constructor(props) {
    super(props);
    this.searchInputRef = React.createRef();
    this.state = {
      show: true,
      loading: true,
      searchInput: '',
      perPage: 5,
      paginationData: [],
      pageCount: 1,
      forcePage: 0,
      showErrorMessage: false,
      errorMessage: '',
    };
    this.grid = createPagedGridController({
      fetchPage: (query) => periodosService.lookupPeriodoExamen(query),
      defaultPageSize: 5,
      onChange: (gridState) => this.applyGridState(gridState),
    });
    const searchHandlers = createLookupSearchHandlers(
      this,
      this.grid,
      (error) => this.handlePeriodosError(error)
    );
    this.handleSearchInputChange = searchHandlers.handleSearchInputChange;
    this.handleSearchSubmit = searchHandlers.handleSearchSubmit;
  }

  handleModal() {
    this.setState({ show: !this.state.show });
    this.props.hideLookup();
  }

  async componentDidMount() {
    const canAccess = await constantClass.canAccess('WWPeriodoExamen');
    if (canAccess) {
      this.populateData();
    }
  }

  applyGridState(gridState) {
    this.setState({
      paginationData: gridState.items,
      pageCount: gridState.pageCount,
      searchInput: gridState.search,
      perPage: gridState.pageSize,
      loading: gridState.loading,
      forcePage: gridState.forcePage,
      showErrorMessage: Boolean(gridState.error),
      errorMessage: gridState.error?.message ?? '',
    });
  }

  handlePageClick = (e) => {
    this.grid.handlePageClick(e).catch((error) => this.handlePeriodosError(error));
  };

  handleItemSelect = (e) => {
    this.props.selectItem(e);
    this.setState({ show: false });
  };

  renderTable(periodos) {
    return (
      <table className="md-lookup__table" aria-label="Seleccionar el Período de Examen">
        <thead>
          <tr>
            <th scope="col">Año Académico</th>
            <th scope="col">Período de Examen</th>
            <th scope="col">Llamado</th>
            <LookupActionHeader />
          </tr>
        </thead>
        <tbody>
          {periodos.map((periodo) => (
            <tr key={periodo.peridoExamenCod}>
              <td>{periodo.anioAcademicoDescripcion}</td>
              <td>{periodo.periodoExamenDescripcion}</td>
              <td>{periodo.periodoExamenLlamado}</td>
              <LookupSelectButton
                onClick={() => this.handleItemSelect(
                  `${periodo.peridoExamenCod}%${periodo.periodoExamenDescripcion}%${periodo.periodoExamenLlamado}%${periodo.anioAcademicoDescripcion}%${periodo.periodoExamenFechaInicio}%${periodo.periodoExamenFechaFin}`
                )}
              />
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  render() {
    return (
      <LookupModal
        show={this.state.show}
        onHide={() => this.handleModal()}
        title="Seleccionar el Período de Examen"
        searchInputRef={this.searchInputRef}
        searchInput={this.state.searchInput}
        searchPlaceholder="Ingrese el Año Académico o Descripción del período o llamado"
        onSearchInputChange={this.handleSearchInputChange}
        onSearchSubmit={this.handleSearchSubmit}
        loading={this.state.loading}
        errorMessage={this.state.showErrorMessage ? this.state.errorMessage : ''}
        pageCount={this.state.pageCount}
        forcePage={this.state.forcePage}
        onPageChange={this.handlePageClick}
      >
        {this.renderTable(this.state.paginationData)}
      </LookupModal>
    );
  }

  handlePeriodosError(error) {
    const outcome = classifyPeriodosError(error);
    if (outcome.type === 'timeout') {
      constantClass.RedirectToLogin();
      return;
    }
    this.setState({
      showErrorMessage: true,
      errorMessage: outcome.message,
      loading: false,
    });
  }

  async populateData() {
    try {
      await this.grid.load();
    } catch (error) {
      this.handlePeriodosError(error);
    }
  }
}
